import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideAlert } from "rivals/redux/alert/actions";
import { AlertTypes } from "rivals/redux/alert/reducer";
import { getAlert } from "rivals/redux/alert/selectors";
import LoginForm from "./LoginForm/container";
import SubscribeToday from "./SubscribeToday";
import styles from "./index.module.scss";
import { OwnProps } from "./types";

const Login = ({ referrerURI }: OwnProps): JSX.Element => {
  const dispatch = useDispatch();
  const alerts = useSelector(getAlert);

  useEffect(() => {
    alerts
      .filter(alert => alert.type === AlertTypes.SEVERE)
      .map(({ id }) => dispatch(hideAlert(id)));
  }, []);

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.flexContainer}>
          <div className={styles.flexContents}>
            <LoginForm redirectURI={referrerURI} />
            <SubscribeToday />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
